{
  "familyId": "TGL-TIJD-PLANNING",
  "questions": [
    {
      "id": "TGL-TIJD-PLANNING-001",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je moet om 15:00 op school zijn. De reis duurt 25 minuten. Hoe laat moet je vertrekken?",
      "options": [
        "14:35",
        "14:25",
        "15:25",
        "14:45"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_backward",
      "variantIndex": 1,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Terugrekenen vanaf aankomsttijd",
            "content": "Je moet om 15:00 aankomen. Trek de reistijd af: 15:00 - 25 minuten = 14:35. Je moet om 14:35 vertrekken."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Trek de reistijd af van de aankomsttijd: 15:00 - 25 minuten = 14:35. Je moet om 14:35 vertrekken.",
        "distractorExplanations": {
          "0": "Correct! 15:00 - 25 minuten = 14:35.",
          "1": "Let op: je moet 25 minuten aftrekken, niet 35 minuten. 15:00 - 25 min = 14:35, niet 14:25.",
          "2": "Bijna! Je hebt de tijd erbij geteld in plaats van eraf te trekken. Je moet eerder vertrekken, niet later: 15:00 - 25 min = 14:35.",
          "3": "Let op: 15:00 - 25 minuten = 14:35, niet 14:45. Je hebt maar 15 minuten afgetrokken in plaats van 25."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-002",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je vertrekt om 13:40 van huis. De reis naar de bioscoop duurt 35 minuten. Hoe laat kom je aan?",
      "options": [
        "14:15",
        "13:75",
        "14:05",
        "14:25"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_forward",
      "variantIndex": 2,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Vooruit rekenen met minuten",
            "content": "Vertrek: 13:40. Tel de reistijd erbij: 13:40 + 35 minuten. Reken: 40 + 35 = 75 minuten = 1 uur en 15 minuten. 13:40 + 1:15 = 14:15."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Tel de reistijd bij de vertrektijd: 13:40 + 35 minuten. 40 + 35 = 75 minuten = 1 uur en 15 minuten. 13:40 + 1:15 = 14:15.",
        "distractorExplanations": {
          "0": "Correct! 13:40 + 35 minuten = 14:15.",
          "1": "Let op: 13:75 bestaat niet. Als je meer dan 60 minuten hebt, moet je dat omzetten naar uren. 75 minuten = 1 uur en 15 minuten, dus 14:15.",
          "2": "Bijna! Je hebt 25 minuten erbij geteld in plaats van 35. 13:40 + 35 min = 14:15, niet 14:05.",
          "3": "Let op: 13:40 + 35 minuten = 14:15, niet 14:25. Je hebt 45 minuten erbij geteld in plaats van 35."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-003",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "De bus vertrekt om 08:15. Je wilt 10 minuten voor vertrek op het busstation zijn. Hoe laat moet je daar zijn?",
      "options": [
        "08:05",
        "08:10",
        "08:25",
        "07:05"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_buffer",
      "variantIndex": 3,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Buffer tijd inplannen",
            "content": "Bus vertrekt: 08:15. Je wilt 10 minuten eerder zijn. Trek 10 minuten af: 08:15 - 10 minuten = 08:05."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Trek de buffertijd af van de vertrektijd: 08:15 - 10 minuten = 08:05. Je moet om 08:05 op het busstation zijn.",
        "distractorExplanations": {
          "0": "Correct! 08:15 - 10 minuten = 08:05.",
          "1": "Bijna! Je hebt maar 5 minuten afgetrokken in plaats van 10. 08:15 - 10 min = 08:05, niet 08:10.",
          "2": "Let op: je moet eerder zijn, niet later. Trek 10 minuten af, niet erbij: 08:15 - 10 min = 08:05, niet 08:25.",
          "3": "Let op: je hebt een heel uur afgetrokken in plaats van 10 minuten. 08:15 - 10 min = 08:05, niet 07:05."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-004",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je afspraak is om 16:30. Je wilt er 15 minuten voor aankomst zijn en de reis duurt 40 minuten. Hoe laat vertrek je?",
      "options": [
        "15:35",
        "15:50",
        "15:45",
        "16:15"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_complex",
      "variantIndex": 4,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Meerdere stappen terugrekenen",
            "content": "Afspraak: 16:30. Eerst 15 minuten eerder: 16:30 - 15 min = 16:15. Dan de reistijd: 16:15 - 40 min = 15:35. Je vertrekt om 15:35."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Reken stap voor stap terug. Eerst 15 minuten eerder: 16:30 - 15 = 16:15. Dan de reistijd: 16:15 - 40 = 15:35.",
        "distractorExplanations": {
          "0": "Correct! 16:30 - 15 min = 16:15, dan 16:15 - 40 min = 15:35.",
          "1": "Let op: je hebt alleen de reistijd afgetrokken (40 min), maar niet de buffertijd (15 min). 16:30 - 15 - 40 = 15:35, niet 15:50.",
          "2": "Bijna! Je hebt 15 + 40 = 55 minuten afgetrokken, maar niet helemaal goed gerekend. 16:30 - 55 min = 15:35, niet 15:45.",
          "3": "Let op: je hebt alleen de buffertijd afgetrokken (15 min), maar niet de reistijd (40 min). 16:30 - 15 - 40 = 15:35, niet 16:15."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-005",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "Je vertrekt om 10:50 en de reis duurt 1 uur en 20 minuten. Hoe laat kom je aan?",
      "options": [
        "12:10",
        "11:10",
        "12:20",
        "11:70"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_long",
      "variantIndex": 5,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Lange reistijd optellen",
            "content": "Vertrek: 10:50. Tel 1 uur erbij: 11:50. Tel dan 20 minuten erbij: 11:50 + 20 min = 12:10."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Tel de reistijd stap voor stap erbij. Eerst 1 uur: 10:50 + 1 uur = 11:50. Dan 20 minuten: 11:50 + 20 min = 12:10.",
        "distractorExplanations": {
          "0": "Correct! 10:50 + 1 uur = 11:50, dan + 20 min = 12:10.",
          "1": "Let op: je hebt alleen 1 uur erbij geteld, maar niet de 20 minuten. 10:50 + 1:20 = 12:10, niet 11:10.",
          "2": "Bijna! Je hebt 1 uur en 30 minuten erbij geteld in plaats van 1 uur en 20 minuten. 10:50 + 1:20 = 12:10, niet 12:20.",
          "3": "Let op: 11:70 bestaat niet. Als je meer dan 60 minuten hebt, moet je dat omzetten naar uren. 70 minuten = 1 uur en 10 minuten, dus 12:10."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-006",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "multiple_choice",
      "question": "De trein vertrekt om 14:45. Je moet 20 minuten voor vertrek inchecken en de reis naar het station duurt 30 minuten. Hoe laat vertrek je van huis?",
      "options": [
        "13:55",
        "14:05",
        "14:15",
        "14:25"
      ],
      "correctAnswer": 0,
      "conceptId": "time_planning_checkin",
      "variantIndex": 6,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Inchecken en reizen",
            "content": "Trein vertrekt: 14:45. Eerst 20 min voor inchecken: 14:45 - 20 = 14:25. Dan 30 min reistijd: 14:25 - 30 = 13:55. Je vertrekt om 13:55."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Reken stap voor stap terug. Eerst inchecktijd: 14:45 - 20 min = 14:25. Dan reistijd: 14:25 - 30 min = 13:55.",
        "distractorExplanations": {
          "0": "Correct! 14:45 - 20 min = 14:25, dan 14:25 - 30 min = 13:55.",
          "1": "Let op: je hebt alleen de reistijd afgetrokken (30 min), maar niet de inchecktijd (20 min). 14:45 - 20 - 30 = 13:55, niet 14:05.",
          "2": "Bijna! Je hebt 20 + 30 = 50 minuten afgetrokken, maar niet helemaal goed gerekend. 14:45 - 50 min = 13:55, niet 14:15.",
          "3": "Let op: je hebt alleen de inchecktijd afgetrokken (20 min), maar niet de reistijd (30 min). 14:45 - 20 - 30 = 13:55, niet 14:25."
        }
      }
    },
    {
      "id": "TGL-TIJD-PLANNING-007",
      "familyId": "TGL-TIJD-PLANNING",
      "module": "TGL",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_planning",
      "questionType": "number_sequence",
      "question": "Vul de ontbrekende tijd in: 09:00, 09:30, __, 10:30",
      "options": [
        "10:00",
        "09:45",
        "10:15",
        "09:15"
      ],
      "correctAnswer": 0,
      "data": {
        "sequence": ["09:00", "09:30", null, "10:30"],
        "missingIndex": 2,
        "correctValue": "10:00"
      },
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 9,
            "end": 11,
            "highlight": [
              9,
              9.5,
              10,
              10.5
            ],
            "label": "Tijdlijn (in uren)"
          }
        }
      ],
      "conceptId": "time_pattern_sequence",
      "variantIndex": 7,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Zoek het patroon: elke stap is 30 minuten later. 09:00 → 09:30 → 10:00 → 10:30. De ontbrekende tijd is 10:00."
      }
    }
  ]
}